import { useTranslation } from 'react-i18next';

import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { IapPollStats } from '~/components/organisms/IapPollStats';
import { IapPollVoteList } from '~/components/organisms/IapPollVoteList';
import { useIapPollQuery } from '~/lib/api/modules/IapPolls/hooks/useIapPollQuery';

export type IIapPollProps = {
  appId: string;
  iapPollId: string;
};

export const IapPoll: React.FC<IIapPollProps> = (props) => {
  const { appId, iapPollId } = props;
  const iapPollQuery = useIapPollQuery({
    appId,
    iapPollId,
  });
  const { t } = useTranslation();

  const iapPoll = iapPollQuery.data;

  return (
    <>
      {iapPollQuery.isError ? (
        <ContentBlock>
          <ContentBlock.Body first>
            <ErrorMessage error={iapPollQuery.error} />
          </ContentBlock.Body>
        </ContentBlock>
      ) : iapPollQuery.isLoading ? (
        <ContentBlock>
          <ContentBlock.Body first>
            {/* TODO: use skeletons */}
            {t('common.loading')}
          </ContentBlock.Body>
        </ContentBlock>
      ) : (
        iapPoll && (
          <>
            <IapPollStats appId={appId} iapPollId={iapPollId} />
            <IapPollVoteList appId={appId} iapPollId={iapPollId} />
          </>
        )
      )}
    </>
  );
};
